<template>
  <v-list-item>
    <v-list-item-action @click="download">
      <v-btn icon :loading="isDownloading">
        <v-icon color="grey">fas fa-cloud-download-alt</v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-avatar>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span class="subtitle-1">{{ document.file_name }}</span>
        <br />
        <span class="text--lighten-2 font-italic">{{ document.tag }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="UserHasRole('Platform')" @click="onDelete">
      <v-btn icon :loading="isDeleting">
        <v-icon color="grey">fas fa-trash-alt</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'document',
  props: ['document'],
  data: () => ({
    isDeleting: false,
    isDownloading: false
  }),
  computed: {
    ...mapGetters(['UserHasRole']),
    icon() {
      const extension = _.last(_.split(this.document.file_name, '.'));
      switch (extension) {
        case 'doc':
        case 'docx':
        case 'odt':
          return 'fas fa-file-word';
        case 'xls':
        case 'xlsx':
        case 'ods':
        case 'csv':
          return 'fas fa-file-excel';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return 'fas fa-file-image';
        case 'pdf':
          return 'fas fa-file-pdf';
        default:
          return 'fas fa-file-alt';
      }
    }
  },
  methods: {
    ...mapActions(['downloadDocument', 'deleteDocument']),
    onDelete() {
      this.isDeleting = true;
      this.deleteDocument(this.document);
    },
    async download() {
      this.isDownloading = true;
      await this.downloadDocument(this.document);
      this.isDownloading = false;
    }
  }
};
</script>

<style scoped></style>
